module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "headshots_BWG_RICH.5d4c4f0e.jpg";